var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",class:{ active: _vm.tooltip.active },style:({ top: _vm.tooltip.top + 'px', left: _vm.tooltip.left + 'px' })},[_vm._v(" "+_vm._s(_vm.tooltip.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }